import { RouteConfig } from "vue-router";

import { PreviewRoute } from "./Preview";
import { FbxRoute } from "./Fbx";

export const ApplicationAdminRoute: Array<RouteConfig> = [
  ...PreviewRoute,
  ...FbxRoute,
];
